module.exports = __webpack_public_path__ + "static/biker-1.inline-dfa2a441e62a2405433f012da685a526.svg";